<template>
  <div class="time-separator">
    <div class="time-label">{{ label }}</div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  label: string
}

defineProps<Props>()
</script>

<style scoped>
.time-separator {
  display: flex;
  align-items: flex-start;
  margin: 0px 0 8px 0;
  /* padding: 0 12px; */
}

.time-label {
  /* font-size: 11px; */
  /* font-weight: 600; */
  color: var(--gd-diary-sub-color);
  /* text-transform: uppercase; */
  letter-spacing: 0.5px;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid var(--border-subtle);
}

</style>
